export default __webpack_public_path__ + "images/WQ.ee1cca4.png";